import { APP_ENVIRONMENT, ZEPTO_DOMAIN } from '@hrms/common/constant/global';
import {
  GetCookieInterface,
  RemoveCookieInterface,
  SetCookieInterface,
} from './types';

export const getCookie: GetCookieInterface = (cookieName) => {
  if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
    const cookies = Object.fromEntries(
      document.cookie
        .split('; ')
        .map((v) => v.split(/=([\s\S]*)/).map(decodeURIComponent)),
    );
    return cookies[cookieName];
  }
  return undefined;
};

export const setCookie: SetCookieInterface = ({
  cookieName,
  value,
  expiryDays,
  hostOnly = false,
}) => {
  if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
    let expires = '';
    let domain = `; domain=${
      APP_ENVIRONMENT !== 'development' ? ZEPTO_DOMAIN : ''
    }`;
    if (expiryDays) {
      const date = new Date();
      date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    if (hostOnly && APP_ENVIRONMENT !== 'development') {
      domain = `; domain=.${ZEPTO_DOMAIN}`;
    }
    document.cookie = `${cookieName}=${value || ''}${expires ?? ''}${
      domain ?? ''
    }; path=/`;
  }
};

export const removeCookie: RemoveCookieInterface = (cookieName) => {
  setCookie({ cookieName });
};

abstract class BaseCookieClient {
  public static getCookie: GetCookieInterface;
  public static setCookie: SetCookieInterface;
  public static removeCookie: RemoveCookieInterface;
}

class CookieManager extends BaseCookieClient {
  public static getCookie = getCookie;
  public static setCookie = setCookie;
  public static removeCookie = removeCookie;
}

export default CookieManager;
